/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class AddNode extends Vue {
    popoverShow = false

    // ------ prop ------
    //  不管添加节点还是条件，都需要拿到当前被添加节点的 children 和 conditions 然后在进行添加动作
    @Prop() childrenNodeP!: any
    @Prop() conditions: any
    // ------ 生命周期 ------
    created(){
        // console.log(this.conditions);
        // console.log(this.childrenNodeP);
    }

    // ------ 方法 ------
    addnode(type: number) {
        if(type !== 3) {
            console.log('添加节点');
            // 在添加节点的时候，不论在哪添加节点都需要拿到当前节点的 chidlren 和 conditions 然后将其赋值给新创建的子节点的 chidlren 和 conditions ，将新创建的节点作为”被添加节点的children"
            let data: any;
            if(type === 0) {
                data = {
                    nodeObject: this.childrenNodeP,
                    conditionList: this.conditions,
                    approvalType: '',
                    approvalPersonOrLevelType: '',
                    approvalPersonOrLevelRange: '',
                    userIdList: '',
                    approvalSettingType: '',
                    approvalSettingUserId: '',
                    infoNode: 0,
                    editFile: [],
                    types: '0'
                }
            } else if(type === 1) {
                data = {
                    nodeObject: this.childrenNodeP,
                    conditionList: this.conditions,
                    approvalType: '',
                    approvalPersonOrLevelType: '',
                    approvalPersonOrLevelRange: '',
                    userIdList: '',
                    // approvalSettingType: '',
                    approvalSettingUserId: '',
                    infoNode: 0,
                    editFile: [],
                    types: '1'
                }
            }
            this.$emit("update:childrenNodeP", data)
            this.$emit("update:conditions", [])
        } else {
            console.log('添加条件');
            // 再添加条件时候，只更新被添加节点的 conditions 其他一律不关
            const arr = [
                {
                    nodeObject: {},
                    priority: '',
                    condition: '',
                    conditionFile: '',
                    conditionCnFile: '',
                    conditionValue: '',
                    conditionCnValue: '',
                    conditionList: this.conditions,    
                },
                {
                    nodeObject: {},
                    priority: '',
                    condition: '',
                    conditionFile: '',
                    conditionCnFile: '',
                    conditionValue: '',
                    conditionCnValue: '',
                    conditionList: [],    
                }
            ]
            // const arr1 = this.conditions.concat(arr)
            this.$emit("update:conditions", arr)
        }
        this.popoverShow = false
    }
}